export default function ToggleIconDirective() {
  return {
    scope: {
      toggleIcon: '=',
      toggleAction: '='
    },
    replace: false,
    link: function ($scope, $element) {
      $element.addClass('toggle ss-icon');

      function toggleIcon(toggleStatus) {
        if (toggleStatus === true) {
          $element.removeClass('ss-directright');
          $element.addClass('ss-dropdown');
        } else {
          $element.removeClass('ss-dropdown');
          $element.addClass('ss-directright');
        }
      }

      toggleIcon($scope.toggleIcon);

      $scope.$watch('toggleIcon', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          toggleIcon(newVal);
        }
      });
    }
    // template: `<i class="toggle ss-icon"
    //               ng-class="{ 'ss-directright': !toggleIcon, 'ss-dropdown': toggleIcon }"
    //               ng-click="toggleAction()" /></i>`
  };
}
